
<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { vendorService ,categoryService} from "../../services";
import { required } from "vuelidate/lib/validators";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import draggable from "vuedraggable";
import { debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination, vendorService, DropzonePopup, draggable, categoryService },
  data() {
    const { status,orderBy,sortBy} = this.$route.query;
    return {
      title: this.trans.get('__JSON__.Sub Category'),
      url: null,
      debounce: false,
      items: [],
      category: [],
      checked: true,
      sortBy: sortBy || "reorder_data",
      sortDesc: orderBy && orderBy != '' ? true : orderBy,
      loading: true,
      paginations: {},
      limit: 1,
      search: "",
      status: status == undefined ? '1' :status,
      config: config,
      category_id: "",
      restaurant_id: "",
      searchData:debounce(()=>{
        if(!this.init){
          const {status,orderBy,sortBy} = this.$data;
          this.$router.replace({name: 'sub-category-list', query: {status,orderBy,sortBy}})
        }
        this.getmenu();
        this.init = false;
      },500),
      
      fields: [
        { key: "category_image_path", label: "#", sortable: false,thClass:"dis-event" },
        { key: "name", label: "Name", sortable: true },
        { key: "status", label: "Status", sortable: false,thClass:"dis-event" },
        { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
      ],
    };
  },
  validations: {
    typeform: {
      menu_name: {
        required,
      },
      image: {
        required,
      },
    }
  },
  mounted() {
    this.getmenu();
    this.getCategoryById();
  },
  methods: {
    checkSubcategoryList() {
     return this.items.length == 0 ? true : false;
    },
    onCategoryImagedeleted(value) {
      this.image = "";
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getmenu();
    },
    getCategoryById() {
      categoryService
        .getCategoryById({ category_id: this.$route.params.category_id })
        .then((response) => {
          this.category = response.data.result.data;
        });
    },
    getmenu(page) {
      this.loading = true;
      vendorService
      .getRestaurantMenu({ 
        restaurant_id: this.restaurant_id, 
        category_id : this.$route.params.category_id, 
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      })
      .then((response) => {
        this.paginations = response.data.result;
        this.items = response.data.result.data;
      });
    },
    deleteMenu(id){
      if(confirm("Do you really want to delete?")){
        vendorService.deleteMenu({id:id})
        .then(response => {
          if (response.data.code === 200) {
            this.getmenu();
            success_message(response.data.message);
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    updateMenuOrder: function() {
      var items = this.items.map(function(item, index) {
        return { item: item, order: index }
      })
      if(this.debounce) return
      var ids = items.map(item => item.item.id);

      this.debounce = setTimeout(function(items) {
        this.debounce = false;
        vendorService.updateMenuOrder({ menu_ids : ids})
        .then(response => {
          if (response.data.code === 200) {
            this.getmenu();
          }
        });
      }.bind(this, items), 10)
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ category.category_name }}</h4>
              <p><router-link :to="{ name: 'category-list'}">{{ trans.get('__JSON__.Categories') }}</router-link> > {{ category.category_name }} > {{ trans.trans('__JSON__.Sub Categories') }}</p>
            </div>
          </div>
          <div class="page-title-right d-flex">
            <router-link :to="{name: 'sub-category-add',params: { category_id: this.$route.params.category_id }}" class="btn btn-success btn-rounded mr-2 add-btn"
              v-if="$auth.hasPermission(config.permissions.category_write)">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Sub Category') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-8">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Status') }} :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                      <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list table-responsive vendor-category sub-cat-table">
                <div class="card task-box sub-cat-table-header">
                  <div class="card-body menu-items">
                    <div class="media">
                      <div class="table-heading mr-4 font-weight-bolder"> # </div>
                      <div class="table-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Name') }} </div>
                      <div class="table-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Description') }} </div>
                      <div class="table-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Status') }} </div>
                      <div class="table-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Action') }} </div>
                    </div>
                  </div>
                </div>
                <draggable class="list-group" group="category" :list="items" v-model="items" @end="updateMenuOrder">
                  <div v-for="category in items" :key="category.id" class="card task-box">
                    <div class="card-body menu-items drag-item">
                      <div class="media">
                        <div class="avatar-md table-heading mr-4">
                          <span class="text-danger font-size-16" v-bind:id="category.id" >
                          <div v-if="category.menu_image_path">
                            <img title="product-img" class="avatar-md rounded-circle-banner" :src="category.menu_image_path" alt height="30" @error="$event.target.src=config.basepath+'no-img.png'"/>
                          </div>
                          <div v-else>
                            <img class="avatar-md rounded-circle-banner" :src="config.basepath+'no-img.png'"/>
                          </div>
                          </span>
                        </div>

                        <div class="table-heading mr-4">
                          <h5 class="font-size-14">{{category.menu_name | truncate(25, '...')}}</h5>
                        </div>

                        <div class="table-heading mr-4">
                          <span>{{category.menu_description | truncate(40, '...')}}</span>
                        </div>

                        <div class="table-heading mr-4">
                          <div v-if="category.status == '1'"  class="badge badge-pill badge-soft-success font-size-12" >{{ trans.get('__JSON__.Active') }}</div>
                          <div v-else class="badge badge-pill badge-soft-danger font-size-12" >{{ trans.get('__JSON__.Inactive') }}</div>
                        </div>

                        <div class="table-heading mr-4">
                          <router-link
                            v-if="$auth.hasPermission(config.permissions.category_write)"
                            :to="{name: 'sub-category-edit', params: { id: base64(category.id) }}"
                            class="btn btn-success btn-sm btn-rounded cursor-pointer"
                          >{{ trans.get('__JSON__.Edit') }}</router-link>
                          <button
                              type="submit"
                              @click="deleteMenu(category.id)"
                              class="btn btn-danger btn-sm btn-rounded ml-1"
                          >{{ trans.get('__JSON__.Delete') }}</button>
                        </div>

                      </div>
                    </div>
                  </div>
                   <p class="text-center" v-if="checkSubcategoryList()">{{ trans.get('__JSON__.No sub category found') }}</p>
                </draggable>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getmenu"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.sub-cat-table-header .card-body{
  height: auto;
  background-color: #b3b0b033 !important;
  border-bottom: 0 solid #b3b0b033 !important;
}
.sub-cat-table .media{
  align-items: center;
}
.table-heading:first-child{
  width: 6rem;
}
.table-heading:nth-child(2){
  width: 8rem;
}
.table-heading:nth-child(3){
  width: 20rem;
}
.table-heading:nth-child(4){
  width: 6rem;
}
.table-heading:nth-child(5){
  width: 8rem;
}
</style>